import * as yup from "yup";



export const secondaryStudentContent = {
    title: "Tell us more about yourself",
    description:
      "We will need some basic information about you before we get started",
    school_name: "School Name",
    state: "State",
    district: "District",
    spm_year: "SPM Year",
    current_form: "Current Form",
    core_subjects: "Core Subject(s)",
    elective_subjects: "Elective Subject(s)",
    elective_subjects_1_3: "Elective Subject(s) Form 1-3",
    stem_subjects: "Are you enrolled in STEM subjects?",
    elective_subjects_4_5: "Elective Subject(s) Form 4-5",
    form_6_subjects: "Form 6 Subject(s)",
   
  };

  export const secondaryFormValues = {
    schools_listing: [{label:"Testing Schools",value: 1}],
    current_form_values: [{ label: 'Form 1', value: 1 },
  { label: 'Form 2', value: 2 },
  { label: 'Form 3', value: 3 },
  { label: 'Form 4', value: 4 },
  { label: 'Form 5', value: 5 },
  { label: 'Form 6', value: 6 },],
    spm_year: [{label: "2021",value: 1},{label: "2022",value: 2},{label: "2023",value: 3},{label: "2024",value: 4},],
    spm_year_form_4: [{label: "2026",value: 2},{label: "2027",value: 3}],
    spm_year_form_5: [{label: "2025",value: 1},{label: "2026",value: 2}],
    core_subjects: [
        {label: "English Language",value: 1},
        {label: "Malay Language",value: 2},
        {label: "Mathematics",value: 3},
        {label: "Islamic Education",value: 4},

    ],
    elective_subjects: [
        {label: "Aquaculture and Recreational Animals",value: 1},
        {label: "Arabic Literature and Rhetoric",value: 2},
        {label: "Contemporary Arabic Language",value: 3},
        {label: "Islamic Science Methodology",value: 4},
        {label: "Islamic Law",value: 5},
    ],
   
  };

  export const secondaryStudyScheme = yup
    .object({
        school_id: yup
        .string()
        .required("School name is required").nullable(),
     spm_year: yup
  .number()
   .transform((value, originalValue) => {
    return originalValue === "" ? null : value;
  })
  .nullable()
  .when("current_form", {
    is: (val) => val >= 1 && val <= 5,
    then: (schema) => schema.required("SPM year is required").nullable(),
    otherwise: (schema) =>
      schema.when("current_form", {
        is: (val) => !val, // when current_form is empty
        then: (s) => s.required("SPM year is required").nullable(),
        otherwise: (s) => s.notRequired(),
      }),
  }),
        school_state: yup
        .number()
        .required("State is required").nullable(),
        school_district: yup
        .number()
        .required("District is required").nullable(),
    elective_subjects_1_3: yup.array().when("current_form", {
    is: (val) => val >= 1 && val <= 3, // ✅ only validate if current_form is 1,2,3
    then: (schema) =>
      schema
        .min(1, "You must choose at least one subject to continue")
        .required("You must choose at least one subject to continue"),
    otherwise: yup.array().notRequired(), // ✅ skip validation for other forms
  }),
  elective_subjects_4_5: yup.array().when("current_form", {
    is: (val) => val >= 4 && val <= 5,
    then: (schema) =>
      schema
        .min(1, "You must choose at least one subject to continue")
        .required("You must choose at least one subject to continue"),
    otherwise: yup.array().notRequired(),
  }),
        form_6_subjects: yup.array().when("current_form", {
    is: 6,
    then: (schema) =>
      schema
        .min(1, "You must choose at least one subject to continue")
        .required("You must choose at least one subject to continue"),
    otherwise: yup.array().notRequired(),
  }),
        stem_subject: yup
       .number()
    .nullable()
    .when("current_form", {
      is: (val) => val >= 4 && val <= 5,
      then: (schema) =>
        schema.nullable().required("STEM Subject is required."),
      otherwise: (schema) => schema.notRequired(),
    }),
        current_form: yup
        .number()
  .transform((value, originalValue) => {
    return originalValue === "" ? null : value;
  })
  .nullable()
  .required("Current form is required"),
        // core_subjects: yup
        // .array()
        // .min(1, "At least one subject is required")
        // .required("You must choose at least one core subject"),
        // elective_subjects: yup
        // .array()
        // .min(1, "At least one subject is required")
        // .required("You must choose at least one elective subject"),
  

    })
    .required();
  export const studyingFields = {
    scholar_status: "",
    scholar_data: "",
    curr_qualification: "",
    insti_location_status: "",
    study_program: "",
    insti_name: "",
    campus: "",
    faculty: "",
    insti_country: "",
    univ_enroll_date: "",
    exp_graduate_date: "",
    curr_study_year: "",
    campusIndicator: false,
    scope: "",
    grade_status: "",
    grade: "",
    english_tests: "",
    english_score: "",
    intern_dur_year: "",
    intern_dur_month: "",
    intern_position: "",
    intern_allowance: "",
    step: 2,
  };